import {
  addDoc,
  collection,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { deleteObject, ref } from "firebase/storage";
import React, { useRef, useState } from "react";
import {
  Button,
  CloseButton,
  Col,
  Dropdown,
  DropdownButton,
  FloatingLabel,
  Form,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useAuth } from "../contexts/AuthContext";
import { database, storage } from "../firebase";
import UploadImages from "./UploadImages";

export default function CreateItemModal({
  edit,
  file,
  showCreate,
  setShowCreate,
  loading,
  setLoading,
}) {
  const { currentUser } = useAuth();

  const titleRef = useRef();
  const descriptionRef = useRef();
  const priceRef = useRef();
  const sizeRef = useRef();
  const nameRef = useRef();
  const emailRef = useRef();
  const phoneRef = useRef();

  const [urls, setUrls] = useState([]);
  const [showContactForm, setShowContactForm] = useState(false);
  const [preferredContact, setPreferredContact] = useState("None");
  const [category, setCategory] = useState("None");

  const displayInputField = (value) => {
    setShowContactForm(true);
    setPreferredContact(value);
  };

  const showToast = (message, type) => {
    const options = { type: type };
    toast(message, options);
  };

  const handleClose = () => {
    setShowCreate(false);
  };

  const closeAbort = () => {
    // Delete uploaded images
    for (var i = 0; i < urls.length; ++i) {
      const pictureRef = ref(storage, urls[i]);

      // Delete the file
      deleteObject(pictureRef)
        .then(() => {
          // File deleted successfully
        })
        .catch((err) => {
          console.error(err);
        });
    }

    setUrls([]);
    handleClose();
  };

  async function closeSave(e) {
    e.preventDefault();

    if (!edit) {
      console.log(urls);

      if (urls.length <= 0) {
        setUrls([]);
        showToast("Bitte mindestens ein Bild hochladen!", toast.TYPE.ERROR);
        return;
      }

      if (category === "None") {
        showToast("Bitte wähle eine Kategorie aus!", toast.TYPE.ERROR);
        return;
      }

      if (preferredContact === "None") {
        showToast(
          "Bitte wähle eine bevorzugte Kontaktmöglichkeit aus!",
          toast.TYPE.ERROR
        );
        return;
      }

      addDoc(collection(database, "soccer"), {
        title: titleRef.current.value,
        description: descriptionRef.current.value,
        price: priceRef.current.value,
        size: sizeRef.current.value,
        name: nameRef.current.value,
        category: category,
        email: emailRef.current.value,
        phone: phoneRef.current.value,
        contact: preferredContact,
        image_urls: urls,
        timestamp: serverTimestamp(),
        uid: currentUser.uid,
      })
        .then((docRef) => {
          //console.log("Document written with ID: ", docRef.id);
        })
        .catch((e) => console.error("Error adding document: ", e));

      setUrls([]);
      handleClose();
      showToast("Artikel erfolgreich hochgeladen.", toast.TYPE.SUCCESS);
    } else {
      let actualCategory = category;
      if (actualCategory === "None") {
        actualCategory = file.category;
      }

      let actualPreferredContact = preferredContact;
      if (actualPreferredContact === "None") {
        actualPreferredContact = file.contact;
      }

      updateDoc(doc(database, "soccer", file.id), {
        title: titleRef.current.value,
        description: descriptionRef.current.value,
        price: priceRef.current.value,
        size: sizeRef.current.value,
        name: nameRef.current.value,
        category: actualCategory,
        email: emailRef.current.value,
        phone: phoneRef.current.value,
        contact: actualPreferredContact,
      });

      handleClose();
      showToast("Artikel erfolgreich bearbeitet.", toast.TYPE.SUCCESS);
    }
  }

  return currentUser ? (
    <div>
      <Modal
        show={showCreate}
        onHide={handleClose}
        keyboard={false}
        backdrop="static"
        fullscreen="sm-down"
        size="lg"
        centered
      >
        <Modal.Header>
          <Modal.Title>Artikel erstellen</Modal.Title>
          <CloseButton disabled={loading} onClick={closeAbort} />
        </Modal.Header>
        <Modal.Body>
          {!edit && currentUser ? (
            <UploadImages
              className="d-flex justify-content-center align-items-center"
              loading={loading}
              setLoading={setLoading}
              urls={urls}
              setUrls={setUrls}
              uid={currentUser.uid}
            />
          ) : (
            <></>
          )}

          <div className="mt-3 d-flex justify-content-center">
            <Form
              onSubmit={closeSave}
              style={{ width: "90%" }}
              autoComplete="off"
            >
              <Form.Group id="title" className="mb-2">
                <FloatingLabel controlId="floatingTitleForm" label="Titel">
                  <Form.Control
                    defaultValue={edit && file ? file.title : ""}
                    type="text"
                    placeholder="Titel"
                    ref={titleRef}
                    required
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group id="description" className="mb-4">
                <Form.Control
                  defaultValue={edit && file ? file.description : ""}
                  as="textarea"
                  rows={2}
                  placeholder="Beschreibung"
                  ref={descriptionRef}
                  required
                />
              </Form.Group>
              <InputGroup id="price" className="mb-2">
                <InputGroup.Text>€</InputGroup.Text>
                <Form.Control
                  defaultValue={edit && file ? file.price : ""}
                  type="text"
                  placeholder="Preis"
                  ref={priceRef}
                  required
                />
              </InputGroup>
              <Form.Group id="selectCategory" className="mb-2">
                <DropdownButton title="Kategorie">
                  <Dropdown.Item onClick={() => setCategory("shirts")}>
                    Trikots und T-Shirts
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setCategory("longsleeves")}>
                    Lange Oberteile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setCategory("shorts")}>
                    Kurze Hosen
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setCategory("trousers")}>
                    Lange Hosen
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setCategory("others")}>
                    Fußballschuhe, Bälle, sonstiges...
                  </Dropdown.Item>

                  {currentUser.uid === "7iyP8mcV9cQ4Q3DzzOtoeWi67S83" ? (
                    <Dropdown.Item onClick={() => setCategory("lost")}>
                      Fundsachen
                    </Dropdown.Item>
                  ) : (
                    <></>
                  )}
                </DropdownButton>
              </Form.Group>
              <Form.Group id="size" className="mb-4">
                <FloatingLabel controlId="floatingTitleForm" label="Größe">
                  <Form.Control
                    type="text"
                    placeholder="Größe"
                    ref={sizeRef}
                    defaultValue={edit && file ? file.size : ""}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group id="selectContact" className="mb-2">
                <DropdownButton title="Bevorzugte Kontaktmöglichkeit">
                  <Dropdown.Item
                    onClick={() => {
                      displayInputField("email");
                    }}
                  >
                    E-Mail
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      displayInputField("phone");
                    }}
                  >
                    Telefonnummer
                  </Dropdown.Item>
                </DropdownButton>
              </Form.Group>
              <Form.Group id="name" className="mb-2">
                <FloatingLabel controlId="floatingNameForm" label="Name">
                  <Form.Control
                    defaultValue={
                      edit && file
                        ? file.name
                        : currentUser
                        ? currentUser.displayName
                        : ""
                    }
                    type="text"
                    placeholder="Name"
                    ref={nameRef}
                    required
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group id="email" className="mb-2">
                <FloatingLabel
                  controlId="floatingEmailForm"
                  label="E-Mail Adresse"
                  style={{
                    color: preferredContact === "email" ? "#F93154" : "",
                  }}
                >
                  <Form.Control
                    defaultValue={
                      edit && file
                        ? file.email
                        : currentUser
                        ? currentUser.email
                        : ""
                    }
                    disabled={!showContactForm}
                    type="text"
                    placeholder="E-Mail Adresse"
                    ref={emailRef}
                    required
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group id="tel" className="mb-4">
                <FloatingLabel
                  controlId="floatingPhoneForm"
                  label="Telefonnummer"
                  style={{
                    color: preferredContact === "phone" ? "#F93154" : "",
                  }}
                >
                  <Form.Control
                    defaultValue={edit && file ? file.phone : "-"}
                    disabled={!showContactForm}
                    type="text"
                    placeholder="Telefonnummer"
                    ref={phoneRef}
                    required
                  />
                </FloatingLabel>
              </Form.Group>
              <div className="d-flex justify-content-between mb-2">
                <Button
                  style={{
                    marginRight: "10px",
                  }}
                  variant="outline-danger"
                  disabled={loading}
                  onClick={closeAbort}
                >
                  <Row>
                    <Col className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                      </svg>
                    </Col>
                    <Col
                      className="d-none d-sm-block"
                      style={{ paddingLeft: "0px" }}
                    >
                      <div style={{ whiteSpace: "nowrap" }}>Abbrechen</div>
                    </Col>
                  </Row>
                </Button>
                <Button
                  style={{
                    marginLeft: "10px",
                  }}
                  variant="outline-success"
                  disabled={loading}
                  type="submit"
                >
                  <Row>
                    <Col className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </Col>
                    <Col style={{ paddingLeft: "0px" }}>
                      <div style={{ whiteSpace: "nowrap" }}>
                        Artikel speichern
                      </div>
                    </Col>
                  </Row>
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  ) : (
    <></>
  );
}
